<!--
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2021-04-01 13:44:14
 * @LastEditors: sueRimn
 * @LastEditTime: 2021-05-06 10:11:23
-->
<template>
  <div id="app">
    <router-view>
    </router-view>
  </div>
</template>

<script>
import { initSocket } from './utils/socketIo.js'
export default {
  name: 'App',
  data() {
    return {

    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      initSocket((res) => {})
    }
  }
}
</script>

<style>
</style>
